<template>
  <div>
    <el-card class="box-card boxcard">
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="公司名称">
          <el-select v-model="formInline.companyname" clearable placeholder="请选择">
            <el-option v-for="item in selectlist" :key="item.ccorpname" :label="item.ccorpname" :value="item.ccorpname"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="询价单号">
          <el-input v-model="formInline.ccode" placeholder="询价单号"></el-input>
        </el-form-item>
        <el-form-item label="合同状态">
          <el-select v-model="formInline.type" placeholder="请选择">
            <el-option label="正在报价" value="0"></el-option>
            <el-option label="报价完毕" value="1"></el-option>
            <el-option label="停止报价" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="存货名称">
          <el-input v-model="formInline.cinvcode" placeholder="存货名称"></el-input>
        </el-form-item>
        <el-form-item label="订单日期">
          <el-date-picker v-model="alwaysUseStartDate" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <!-- <el-button type="primary" @click="onSubmit">查询</el-button> -->
          <Debounce :time='300' :isDebounce="1">
            <el-button type="primary" @click.native="GetOperationRKorderReportList()" size="medium">查询</el-button>
          </Debounce>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card class="box-card">
      <div class="text item text-center">
        <!-- <div class="pull-right" style="margin-bottom:15px">
          <el-button type="success" size="medium">填写运费</el-button>
          <el-button type="info" size="medium">填写送货截止日期</el-button>
          <el-button type="primary" size="medium">报价</el-button>
          <el-button type="warning" size="medium" icon="el-icon-aim">记录</el-button>
        </div> -->
        <el-table :data="tableData1" style="width: 100%" max-height="480" border :cell-style="{ padding: '7px 0' }">
          <el-table-column type="index" label="主键" width="50"></el-table-column>
          <el-table-column prop="content" label="询价单号" width="220"></el-table-column>
          <el-table-column prop="content" label="分组" width="220"></el-table-column>
          <el-table-column prop="content" label="状态" width="90"></el-table-column>
          <el-table-column prop="content" label="询价日期" width="120"></el-table-column>
          <el-table-column prop="content" label="截止报价日期" width="120"></el-table-column>
          <el-table-column prop="content" label="牧场" width="220"></el-table-column>
          <el-table-column prop="content" label="物料单号" width="120"></el-table-column>
          <el-table-column prop="content" label="物料名称" width="120"></el-table-column>
          <el-table-column prop="content" label="物料规格" width="90"></el-table-column>
          <el-table-column prop="content" label="品牌" width="90"></el-table-column>
          <el-table-column prop="content" label="采购单位" width="120"></el-table-column>
          <el-table-column prop="content" label="数量" width="90"></el-table-column>
          <el-table-column prop="content" label="特殊需求" width="120"></el-table-column>
          <el-table-column prop="content" label="本次报价" width="90"></el-table-column>
          <el-table-column prop="content" label="我的报价" width="90"></el-table-column>
          <el-table-column prop="content" label="运费" width="90"></el-table-column>
          <el-table-column prop="content" label="总金额" width="90"></el-table-column>
          <el-table-column prop="content" label="报价有效天数" width="90"></el-table-column>
          <el-table-column prop="content" label="已报价次数" width="90"></el-table-column>
          <el-table-column prop="content" label="允许报价次数" width="90"></el-table-column>
          <el-table-column prop="content" label="送货截止日期" width="120"></el-table-column>
          <el-table-column prop="content" label="打包方式" width="120"></el-table-column>
          <el-table-column prop="content" label="供应商名称" width="120"></el-table-column>
          <el-table-column prop="content" label="紧急申购" width="120"></el-table-column>
          <el-table-column prop="content" label="前置定价" width="120"></el-table-column>
          <el-table-column prop="content" label="送货地址" width="120"></el-table-column>
          <el-table-column prop="content" label="备注" width="120"></el-table-column>
          <!-- <el-table-column  label="操作" width="150">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" plain @click="read(scope.row)">查看</el-button>
        </template>
       </el-table-column> -->
        </el-table>
      </div>
      <div class="pull-right" style="padding:20px">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="[10,20, 50, 100, 1000]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalCount">
        </el-pagination>
      </div>
    </el-card>

  </div>
</template>

<script>
export default {
  data() {
    return {
      alwaysUseStartDate: [],
      formInline: {
        cztcode: "",
        ccode: "",
        cinvcode: "",
        type: "",
        startDate: "",
        endDate: "",
      },
      notvisi: false,
      NoticeDel: {},
      tableData1: [],
      // 牧场
      selectlist: {},
      // 分页
      pageSize: 10,
      pageIndex: 1,
      // 页数
      totalCount: 0,
    };
  },
  created() {
    this.GetOperationRKorderReportList();
    this.GetAccountInfo();
  },
  methods: {
    // 获取table 信息
    GetOperationRKorderReportList() {
      var starttime;
      var endtime;
      if (this.formInline.ddeliverytime != null) {
        if (this.formInline.ddeliverytime.length != 0) {
          starttime = this.formInline.ddeliverytime[0];
          endtime = this.formInline.ddeliverytime[1];
        } else {
          starttime = "";
          endtime = "";
        }
      } else {
        starttime = "";
        endtime = "";
      }
      console.log(starttime, endtime);
      this.$axios({
        method: "post",
        url: "CommonModule/Op_SupplierDD/GetOperationRKorderReportList",
        //data: this.formInline,
        data: {
          startDate: starttime,
          endDate: endtime,
          cztcode: this.formInline.cztcode,
          ccode: this.formInline.ccode,
          cinvcode: this.formInline.cinvcode,
          type: this.formInline.type,
        },
      }).then((res) => {
        console.log(res);
        if (res.data.Data.rows) {
          this.tableData = res.data.Data.rows;
          this.totalCount = res.data.Data.totalCount;
        }
      });
    },
    // 获取公司信息2
    GetAccountInfo() {
      this.$axios({
        method: "post",
        url: "CommonModule/Op_StoreAndInvoice/GetAccountInfo",
      }).then((res) => {
        console.log(res);
        if (res.data.Success) {
          if (res.data.Message) {
            this.selectlist = res.data.Data;
          }
        } else {
          this.$message.error(res.data.Message);
        }
      });
    },

    // 分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.GetOperationRKorderReportList();
    },
    // 分页
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.GetOperationRKorderReportList();
    },
  },
};
</script>


